import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Container, Row, Col } from 'react-bootstrap';
import * as api from '~/Services/Service';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import Loading from '~/Components/Loading';
import FiltrosRelatorio from './FiltrosRelatorio';
import GraficoBarraLinha from './GraficoBarraLinha';
import GraficoStackedBarraLinha from './GraficoStackedBarraLinha';

const RelatorioLancamento = () => {
  const [dados, setDados] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [dadosIniciais, setDadosIniciais] = useState(null);
  const [isLoadingIniciais, setIsLoadingIniciais] = useState(false);

  useEffect(() => {
    const carregarDadosIniciais = async () => {
      setIsLoadingIniciais(true);
      try {
        const response = await api.obterDadosIniciaisLancamento();
        setDadosIniciais(response);
      } catch {
        toast.error('Erro ao carregar dados iniciais.');
      } finally {
        setIsLoadingIniciais(false);
      }
    };
    carregarDadosIniciais();
  }, []);

  const handleSubmit = async values => {
    if (!values.codigo_familia) {
      toast.warn('Por favor selecione um empreendimento.');
      return;
    }

    setIsLoading(true);
    setDados(null);

    try {
      const filtros = {
        codigo_familia: values.codigo_familia,
        data_inicial: values.data_inicial || null,
        data_final: values.data_final || null,
      };

      const response = await api.consultarRelatorioLancamento(filtros);

      if (response.total_clientes === 0) {
        toast.info('Nenhum checkin encontrado, verifique os parametros informados.');
        return;
      }

      setDados(response);
    } catch (err) {
      toast.error(err.message || 'Erro ao consultar relatorio.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container fluid className="px-3 py-3">
      <HeaderAzul title="Lançamento" />

      <FiltrosRelatorio
        onSubmit={handleSubmit}
        isLoading={isLoading}
        dadosIniciais={dadosIniciais}
        isLoadingIniciais={isLoadingIniciais}
      />

      {isLoading && <Loading label="Carregando relatorio" />}

      {dados && (
        <>
          <h5 className="mb-3">
            Total de Clientes: <strong>{dados.total_clientes}</strong>
          </h5>

          <Row>
            <Col xs={12} className="mb-3">
              <GraficoBarraLinha
                titulo="Funil de Etapas do Lançamento"
                dados={dados.grafico_checkin}
                index={0}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} className="mb-3">
              <GraficoBarraLinha
                titulo="Conversao de vendas por tipo de cadastro"
                dados={dados.grafico_conversao_vendas}
                index={1}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <GraficoStackedBarraLinha
                titulo="Tipos de cadastros que compareceram"
                dados={dados.grafico_tipos_compareceram}
                index={2}
              />
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default RelatorioLancamento;
